/**
 * פאנל התראות — צף בפינת המסך
 * מציג את 10 האירועים האחרונים שקשורים לחצר של השחקן
 */

import { useEffect, useState } from 'react';
import type { RoundPlayer } from '../../api/client.js';
import type { WorldState } from '../RoundScreen.js';

export function NotificationsPanel({
  state,
  player,
}: {
  state: WorldState;
  player: RoundPlayer;
}) {
  const [open, setOpen] = useState(false);
  const [seenTick, setSeenTick] = useState(0);

  // סנן אירועים שרלוונטיים לשחקן
  const myEvents = state.log
    .filter((e) => e.relatedIds.includes(player.dynasty_id))
    .slice(-20)
    .reverse();

  const unread = myEvents.filter((e) => e.tick > seenTick).length;

  useEffect(() => {
    if (open) {
      setSeenTick(state.meta.tickNumber);
    }
  }, [open, state.meta.tickNumber]);

  return (
    <>
      <button
        className={`notif-btn ${unread > 0 ? 'has-unread' : ''}`}
        onClick={() => setOpen(!open)}
        title="התראות"
      >
        🔔
        {unread > 0 && <span className="unread-count">{unread}</span>}
      </button>

      {open && (
        <div className="notif-panel" onClick={(e) => e.stopPropagation()}>
          <div className="notif-header">
            <h3>התראות</h3>
            <button onClick={() => setOpen(false)}>✕</button>
          </div>
          <div className="notif-body">
            {myEvents.length === 0 ? (
              <div className="empty">אין התראות</div>
            ) : (
              myEvents.map((e, i) => (
                <div key={i} className={`notif-item ${e.category}`}>
                  <div className="msg">{e.message}</div>
                  <div className="meta">יום {e.tick}</div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </>
  );
}
